import { Box } from "@mui/material";

import { LeftSidebar } from "./components/LeftSidebar";
import { Main } from "./components/Main";
import { Sidebar } from "./components/Sidebar";

export const App = () => {
  return (
    <Box sx={appWrapperStyles}>
      <LeftSidebar />
      <Box sx={appContainerStyles}>
        <Main/>
        <Sidebar />
      </Box>
    </Box>
  );
};

const appWrapperStyles = {
  display: 'flex',
  minHeight: '100vh',
  backgroundColor: '#fff',
};

const appContainerStyles = {
  display: 'flex',
  marginLeft: '240px',
  flex: 1,
  justifyContent: 'center',
  maxWidth: '100%',
  '@media (max-width: 768px)': {
    marginLeft: 0,
  },
};
